export default "__VITE_ASSET__HoBCxaE5__"